module.exports = "static/assets/48df3abff5e8eb9a597f355daaf5348c.png";